import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconUnder from '@src/assets/images/common/icon/editor/SvgIconUnder';
import type { Editor } from '@tiptap/react';
import React from 'react';

interface UnderlineButtonProps {
  editor: Editor;
  isActive: boolean;
  refreshActiveState: () => void;
}

export const UnderlineButton: React.FC<UnderlineButtonProps> = ({
  editor,
  isActive,
  refreshActiveState,
}) => {
  const activeHoverColor = brandColors['500'] || '#2B5CDD';
  const defaultIconColor = 'currentColor';

  return (
    <button
      onClick={() => {
        editor.view.dom.focus({ preventScroll: true });
        editor.chain().toggleUnderline().run();
        refreshActiveState();
      }}
      className={`toolbar-button ${isActive ? 'active' : ''}`}
      title='下線'
      type='button'
    >
      <SvgIconUnder color={isActive ? activeHoverColor : defaultIconColor} />
    </button>
  );
};
